import { AuthLayout, PendingScreen, useAuthStore } from '@classgo/app-kit';
import { Link, useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { useT } from '../../i18n';

const readHandover = (hash: string) => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const sessionId = params.get('session');
  const tenantId = params.get('tenant');
  const idToken = params.get('token');
  const email = params.get('email');
  const expiresAt = Number(params.get('expires'));
  if (!sessionId || !tenantId || !idToken || !email || !Number.isFinite(expiresAt)) return null;
  if (expiresAt * 1000 <= Date.now()) return null;
  return { email, idToken, expiresAt, actAs: { sessionId, tenantId } };
};

/**
 * Entry point of a ClassGO staff member coming from the console: the handover travels in the
 * URL fragment (never sent to a server), is consumed once, removed from the address bar and
 * kept per tab until the act-as session expires.
 */
export const ActAsScreen = () => {
  const t = useT();
  const auth = useAuthStore();
  const router = useRouter();
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    const handover = readHandover(window.location.hash);
    if (!handover) {
      setInvalid(true);
      return;
    }
    window.history.replaceState(null, '', window.location.pathname);
    auth.completeActAs(handover);
    router.history.push('/');
  }, [auth, router]);

  if (!invalid) return <PendingScreen />;
  return (
    <AuthLayout
      title={t('actAs.invalid.title')}
      subtitle={t('actAs.invalid.body')}
      footer={
        <Link
          to="/login"
          search={{ redirect: undefined }}
          className="text-brand-600 underline underline-offset-2 hover:decoration-2"
        >
          {t('login.title')}
        </Link>
      }
    >
      <span />
    </AuthLayout>
  );
};
